export default __webpack_public_path__ + "static/media/Goal_6.c47a4824.zip";